
// src/helpers/is-stamp.js

// commentの内容がスタンプかどうかを判定します
export function isCommentStamp(comment) {
	return !!comment.match(/<span class=[\'\"]stamp[^"]+[\"\']><\/span>/i)
}



// WEBPACK FOOTER //
// ./src/helpers/is-stamp.js